import { useContext } from "react";
import { Link } from "react-router-dom";
import { BreadcrumbContext } from "../../../context/BreadcrumbContext";

const Breadcrumbs = () => {
  const { breadcrumbs } = useContext(BreadcrumbContext);

  if (!breadcrumbs.length) return null;

  return (
    <nav className="breadcrumbs">
      <ol className="breadcrumbs-list">
        {breadcrumbs.map((item, index) => (
          <li key={index} className="breadcrumbs-item">
            {item.path ? (
              <Link to={item.path} className="breadcrumbs-link">
                {item.label}
              </Link>
            ) : (
              <span className="breadcrumbs-current">{item.label}</span>
            )}
            {index < breadcrumbs.length - 1 && (
              <span className="breadcrumbs-separator">/</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
